module.exports = __webpack_public_path__ + "static/media/jrpg.6316f240.png";